const o = {
  // function buyPass(string memory name, uint256 qty, string memory token) public {
  buyPass:
    "function buyPass(string memory name, uint256 qty, string memory token) public",
};

export default o;
